/**
 * Keeping the popup above everything, including our own chat widget.
 *
 * The host already sits at z-index 2147483647 (the max 32-bit int), which is
 * where every aggressive storefront embed parks itself — Smile.io, Judge.me,
 * Gorgias, and as of 18 Sep 2026 the FlowIQ chat widget, which had to go there
 * to stop a rewards launcher covering its input row.
 *
 * At an equal z-index the later element in DOCUMENT ORDER wins, so "who is on
 * top" is decided by position in <body>. A BLOCKING popup must outrank the
 * chat widget: the widget's own "Get 10% off" card calls
 * ReactPopupWidget.open(), and a popup that opened behind the panel would be
 * invisible.
 *
 * The TEASER deliberately does NOT call this. It is a small edge tab, and on a
 * phone the chat panel is fullscreen — a teaser painted over it is exactly the
 * clash Thys Meyer reported on leanliving.co.za. Leaving the host where it is
 * keeps the teaser behind an open panel.
 */
const DEFAULT_HOST_ID = "react-popup-widget-container";

/** Move the popup host to the end of <body> so a blocking popup wins the tie. */
export function raisePopupHost(hostId: string = DEFAULT_HOST_ID): void {
  if (typeof document === "undefined") return;
  const host = document.getElementById(hostId);
  if (!host || host.parentElement !== document.body) return;
  if (document.body.lastElementChild === host) return;
  document.body.appendChild(host);
}
